import axios from "axios";
import router from "@/router";
import { ElMessage } from "element-plus";
const instance = axios.create({
  baseURL: "/api/v1",
  timeout: 3600000, // 一小时
  //Authorization
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    // const token = sessionStorage.getItem("token");
    // 从 localStorage 中获取 token
    const token = localStorage.getItem("token");
    const ttl = localStorage.getItem("ttl");
    //now 当前时间时间戳
    const now = new Date().getTime();
    // 如果 token 过期了, 清除 token, 并重定向到登录页
    if (Number(ttl) < now) {
      localStorage.removeItem("token");
      localStorage.removeItem("ttl");
      localStorage.removeItem("userInfo");
      router.push("/");
    } else {
      if (token) {
        config.headers.Authorization = token; // 设置 Authorization 头
        // 设置本地的cookie
        document.cookie = `token=${token}; path=/`;
        // 设置响应超时时间为1小时
        config.timeout = 3600000;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.headers["content-type"] !== "application/json") {
      return response;
    } else {
      return response.data;
    }
  },
  (error) => {
    //限制最多只弹出5个错误
    ElMessage({
      message: error.response.data.message,
      type: "error",
      grouping: true,
    });
    console.log("error", error);
    // 401 未授权
    if (error.response.status === 401 || error.response.status === 403) {
      // 重定向到登录页, 清除 token
      // sessionStorage.removeItem("token");
      localStorage.removeItem("token");
      localStorage.removeItem("ttl");
      localStorage.removeItem("userInfo");
      router.push("/");
    }
    return Promise.reject(error);
  }
);

export default instance;
